import { Dialog } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CLOSE_ICON from '../../assets/svg/close-icon.svg';
import { LANG_TEXT } from '../../constants/language';
import Button from '../Button/Button';
import { cancelButtonStyle, confirmButtonStyle, useStyles, warningButtonStyle } from './styles';

interface ModalCustomProps {
  handleSubmit: () => void;
  open: boolean;
  handleClose: () => void;
  title: string;
  description: string;
  variant?: 'success' | 'warning';
}

const Modal: React.FC<ModalCustomProps> = ({ handleSubmit, open, handleClose, title, description, variant = 'success' }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog className={classes.Modal} open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box className={classes.Box}>
        <Box className={classes.BoxHeader}>
          <Box className={classes.BoxTitleModal}>
            <Box className={classes.TitleModal}>
              <Typography fontSize={18} fontWeight={600} lineHeight={'28px'} color={'var(--Gray-900, #101828)'}>
                {title}
              </Typography>
            </Box>
            <Box className={classes.Icon} onClick={handleClose}>
              <img src={CLOSE_ICON} height={20} width={20} alt="CLOSE_ICON" />
            </Box>
          </Box>
        </Box>
        <Box className={classes.BoxContent}>
          <Typography fontSize={14} lineHeight={'20px'} color={'var(--Gray-600, #475467)'}>
            {description}
          </Typography>
        </Box>
        <Box className={classes.BoxFooter}>
          <Button
            id="cancel_button"
            fullWidth={false}
            title={t(LANG_TEXT.CANCEL)}
            buttonStyle={cancelButtonStyle}
            sxTextStyle={{ color: 'var(--Gray-700, #344054)', fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}
            onClick={handleClose}
          />
          <Button
            id="confirm_button"
            fullWidth={false}
            title={t(LANG_TEXT.CONFIRM)}
            buttonStyle={variant === 'success' ? confirmButtonStyle : warningButtonStyle}
            sxTextStyle={{ color: 'var(--Base-White, #FFF)', fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}
            onClick={() => {
              handleSubmit();
              handleClose();
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default Modal;
